<template lang="pug">
.breadcrumbs
  transition(name="slide-vertical")
    .container.mx-auto.px-4(v-if="activeMenuItems.ancestors.length")
      .panel
        template(v-for="ancestor in activeMenuItems.ancestors")
          Ancestor(
            :key="ancestor.id"
            :item="ancestor"
          )
          .divider /
        .current-item {{ activeMenuItems.current.title }}
</template>

<script>
import { mapGetters } from 'vuex';

import { get, cloneDeep } from '@/helpers';
import NestedSet from '@/nested-set-lib';

import Ancestor from './Ancestor';

export default {
  name: 'BreadcrumbNav',
  props: {
    title: {
      type: String
    }
  },
  components: {
    Ancestor
  },
  computed: {
    activeMenuItems() {
      let activeItems = {
        current: undefined,
        ancestors: []
      };

      let items;
      const check = path => {
        this.menus.forEach(menu => {
          if (activeItems.current) return;

          items = get(menu, 'menuItems') || [];
          activeItems.current = items.find(el => el.path === path);
        });
      };

      if (this.$route.name === 'product-details') {
        let path = '/';

        // NOTE: can not get from SetupAPI .. apollo error
        const history = JSON.parse(window.sessionStorage.getItem('history')) || [];
        if (history.length) {
          history.forEach(path => {
            if (activeItems.current) return;
            check(path);
          });
        } else {
          check(path);
        }
      } else {
        const path = this.$route.path;
        check(path);
      }

      if (activeItems.current) {
        activeItems.ancestors = NestedSet.getAncestors(cloneDeep(items), activeItems.current);
        // activeItems = [...ancestors, item];

        if (this.title && this.$route.name === 'product-details') {
          activeItems.ancestors.push(activeItems.current);
          activeItems.current = { title: this.title };
        }
      }

      return activeItems;
    },
    ...mapGetters({
      menus: 'menus'
    })
  }
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.breadcrumbs
  background: $backgroundColor
  display: none
  @screen lg
    display: block
  .container
    padding-top: 1rem
    padding-bottom: 1rem
  .panel
    // @apply flex rounded-none shadow-none
    // padding: 0
    // background: none
    @apply flex rounded bg-gray-200 shadow-none
    a
      text-decoration: none
      // font-weight: bold
      // text-transform: uppercase
      &:hover,
      &:active
        text-decoration: underline
    div
      @apply text-gray-500
      // font-weight: bold
      // text-transform: uppercase
    .divider
      @apply text-gray-400
      margin: 0 .5rem
</style>
